import { getStripeCustomApiKey } from '../apis/stripe';

let stripeCustomApiKey: any;

const stripeCustomApiKeyValue = async () => {
  if (!stripeCustomApiKey) {
    stripeCustomApiKey = await getStripeCustomApiKey();
  }
  return stripeCustomApiKey;
};

export default stripeCustomApiKeyValue;